import {
  Component,
  inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppModule } from '../../../app-module';
import { Documents } from '../../../commons/class/archivo.inteface';
import { ListaArchivosComponent } from '../../../commons/components/downLoadFile/lista-archivos/lista-archivos.component';
import { NotificacionesService, Notificacion, ActualizarEstatusNotificacionesPslCommand } from './notificaciones.service';
import { ConfirmationDialogService } from '../../../commons/components/confirm-dialog/confirm-dialog.service';
import { AuthService } from '../../../commons/services/auth.service';
import { ExportarExcel } from "../../../commons/shared/Excel/exportar-excel/exportar-excel";
import DOMPurify from 'dompurify';

const CLASIFICACIONES: Record<number, string> = {
  0: 'Sin Clasificación',
  1: 'Determinación Judicial',
  2: 'Anexo Determinación Judicial',
  3: 'Promoción',
  4: 'Notificaciones',
  5: 'Intercambio CJF',
  6: 'Oficio Interconexión',
  7: 'Demanda Electrónica',
};

@Component({
  selector: 'oaj-notificaciones-general',
  templateUrl: './notificaciones.component.html',
  styleUrls: ['./notificaciones.component.css'],
  imports: [AppModule, ListaArchivosComponent, ExportarExcel],
  providers: [ConfirmationDialogService, AuthService]
})
export class NotificacionesComponent implements OnInit, OnChanges {
  @Input() iEstatus: number | string | null = null;
  filtrosForm!: FormGroup;
  notificaciones: Notificacion[] = [];
  filteredNotificaciones: Notificacion[] = [];
  pagedNotificaciones: Notificacion[] = [];
  listaNotificacionesParaNotificar: Notificacion[] = [];
  loading = false;
  errorMessage = '';
  pageSizes: number[] = [5, 10, 15];
  pageSize = 5;
  currentPage = 1;
  private selectAll = false;
  @ViewChild('modalArchivos') modalArchivosTpl?: TemplateRef<any>;
  archivosModal: Documents[] = [];
  archivosModalLoading = false;
  archivosModalError = '';
  readonly clasificacionNotificacion = 4;
  @ViewChild('modalConstancia') modalConstanciaTpl?: TemplateRef<any>;
  notificacionConstancia?: Notificacion;
  constanciaArchivos: Documents[] = [];
  constanciaLoading = false;
  constanciaError = '';
  successMessage = '';
  private successTimeoutId?: number;
  leyenda = '';
  columnasNotificadas = [
    {
      header: '#', key: '#', width: 10,
      transform: (_: any, __: any, index?: number) => (index ?? 0) + 1
    },
    { header: 'Circuito', key: 'circuito', width: 10 },
    { header: 'Órgano Jurisdiccional PJF', key: 'organoJurisdiccionalPJF', width: 60 },
    { header: 'Neun', key: 'neun', width: 15 },
    { header: 'Expediente', key: 'expediente', width: 15 },
    { header: 'Tipo Asunto', key: 'tipoAsunto', width: 20 },
    { header: 'Tipo Cuaderno', key: 'sTipoCuaderno', width: 30 },
    {
      header: 'Fecha Determinación', key: 'fechaAcuerdo', width: 25,
      transform: (val: string) => {
        if (!val) return '';
        const fecha = new Date(val);
        return fecha.toLocaleDateString('es-MX', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      }
    },
    {
      header: 'Fecha Publicación', key: 'fechaPublica', width: 25,
      transform: (val: string) => {
        if (!val) return '';
        const fecha = new Date(val);
        return fecha.toLocaleDateString('es-MX', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      }
    },
    {
      header: 'Fecha Recepción', key: 'fechaRecepcion', width: 25,
      transform: (val: string) => {
        if (!val) return '';
        const fecha = new Date(val);
        return fecha.toLocaleDateString('es-MX', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      }
    },
    {
      header: 'Tipo de Constancia', key: 'iTipoNotificacion', width: 20,
      transform: (val: number) => {
        if (!val) return '';
        if (val == 1) return 'Normal'
        else return 'Automática'
      }
    },
    {
      header: 'Fecha Notificación', key: 'fechaNotificacion', width: 30,
      transform: (val: string) => {
        if (!val) return '';
        if (val == '0001-01-01T00:00:00') return '';
        const fecha = new Date(val);
        return fecha.toLocaleDateString('es-MX', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }) + ' ' + fecha.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
      }
    },
    { header: 'Nombre de la Autoridad', key: 'autoridad', width: 30 },
    { header: 'Carácter de la Autoridad', key: 'caracterAutoridad', width: 30 },
  ];

  columnasNoNotificadas = [
    {
      header: '#', key: '#', width: 10,
      transform: (_: any, __: any, index?: number) => (index ?? 0) + 1
    },
    { header: 'Circuito', key: 'circuito', width: 10 },
    { header: 'Órgano Jurisdiccional PJF', key: 'organoJurisdiccionalPJF', width: 60 },
    { header: 'Neun', key: 'neun', width: 15 },
    { header: 'Expediente', key: 'expediente', width: 15 },
    { header: 'Tipo Asunto', key: 'tipoAsunto', width: 20 },
    { header: 'Tipo Cuaderno', key: 'sTipoCuaderno', width: 30 },
    {
      header: 'Fecha Determinación', key: 'fechaAcuerdo', width: 25,
      transform: (val: string) => {
        if (!val) return '';
        const fecha = new Date(val);
        return fecha.toLocaleDateString('es-MX', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      }
    },
    {
      header: 'Fecha Publicación', key: 'fechaPublica', width: 25,
      transform: (val: string) => {
        if (!val) return '';
        const fecha = new Date(val);
        return fecha.toLocaleDateString('es-MX', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      }
    },
    {
      header: 'Fecha Recepción', key: 'fechaRecepcion', width: 25,
      transform: (val: string) => {
        if (!val) return '';
        const fecha = new Date(val);
        return fecha.toLocaleDateString('es-MX', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      }
    },
    { header: 'Nombre de la Autoridad', key: 'autoridad', width: 30 },
    { header: 'Carácter de la Autoridad', key: 'caracterAutoridad', width: 30 },
  ];

  columnasReporte: any[] = [];
  subtituloReporte!: string;
  periodoFechaInicio!: string;
  periodoFechaFin!: string;
  nombreAutoridad!: string;
  bOrganoSupervisado = false;

  private fb: FormBuilder = inject(FormBuilder);
  private notificacionesService: NotificacionesService = inject(NotificacionesService);
  private modalService: NgbModal = inject(NgbModal);
  private modalConfirmacionService: ConfirmationDialogService = inject(ConfirmationDialogService);
  private authService: AuthService = inject(AuthService);


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['iEstatus'] && !changes['iEstatus'].firstChange && this.filtrosForm) {
      this.aplicarFechasPorEstatus();
      this.buscar();
      this.handleSelectionState();
    }
  }

  ngOnInit(): void {
    this.nombreAutoridad = '(' + this.authService.getIdOrgan() + ') ' + this.authService.getNameCourt();
    this.bOrganoSupervisado = this.authService.getEsOrganoSupervisado();
    const { fechaInicio, fechaFin } = this.obtenerFechasPorEstatus();
    this.filtrosForm = this.fb.group({
      fechaInicio: [fechaInicio],
      fechaFin: [fechaFin],
      filtroGeneral: [''],
      numExpediente: [''],
      organo: [''],
      tipoFiltro: [1],
    });

    this.actualizarTotalesSidebar();
    this.buscar();
  }

  /**
   * Funcion para buscar notificaciones según los filtros aplicados
   */

  buscar(): void {
    const { fechaInicio, fechaFin } = this.filtrosForm.value;

    if (!fechaInicio || !fechaFin) {
      this.errorMessage = 'Selecciona el rango de fechas para realizar la busqueda.';
      return;
    }

    const inicioParam = this.composeFechaParametro(fechaInicio);
    const finParam = this.composeFechaParametro(fechaFin);
    const estatusParam = this.toNumber(this.iEstatus);
    const tipoFiltro = this.filtrosForm.get('tipoFiltro')?.value;

    this.loading = true;
    this.errorMessage = '';

    this.columnasReporte = this.iEstatus === 1 ? this.columnasNotificadas : this.columnasNoNotificadas;
    this.subtituloReporte = this.TitleFiltro(tipoFiltro);
    this.periodoFechaInicio = this.FormateoFechaReporte(inicioParam);
    this.periodoFechaFin = this.FormateoFechaReporte(finParam);

    this.notificacionesService
      .buscarPorFechaEnvio(inicioParam, finParam, estatusParam, tipoFiltro)
      .subscribe({
        next: (notificaciones) => {
          this.notificaciones = notificaciones;
          this.notificaciones.forEach((n) => {
            n.TipoNotificacion = this.getTipoConstancia(n);
            n.fechaPublica = n.fechaPublica == '1900-01-01T00:00:00' ? '' : n.fechaPublica;
            n.fechaRecepcion = n.fechaRecepcion == '1900-01-01T00:00:00' ? '' : n.fechaRecepcion;
          });
          this.applyFilters();
          this.loading = false;
          this.resetSeleccion();
        },
        error: () => {
          this.errorMessage =
            'Ocurrio un error al recuperar las notificaciones, intenta nuevamente.';
          this.notificaciones = [];
          this.filteredNotificaciones = [];
          this.pagedNotificaciones = [];
          this.loading = false;
          this.resetSeleccion();
        },
      });
  }

  /**
   * Funcion para obtener el título del filtro según el tipo seleccionado
   * @param tipoFiltro 
   * @returns 
   */
  TitleFiltro(tipoFiltro: number): string {
    switch (tipoFiltro) {
      case 1:
        return 'Fecha de determinación';
      case 2:
        return 'Fecha de publicación';
      case 3:
        return 'Fecha de notificación';
      case 4:
        return 'Fecha de recepción';
      default:
        return '';
    }
  }

  /**
   * Funcion para formatear la fecha para el reporte
   * @param fecha 
   * @returns 
   */
  FormateoFechaReporte(fecha: string): string {
    const date = new Date(fecha + 'T00:00:00');
    const dia = date.getDate().toString().padStart(2, '0');
    const mes = (date.getMonth() + 1).toString().padStart(2, '0');
    const anio = date.getFullYear();
    return `${dia}/${mes}/${anio}`;
  }

  /**
   * Funcion para manejar el evento de cambio en los filtros, se aplica el filtro general a la lista de notificaciones y se actualiza la paginación
   */
  onFilterInputChange(): void {
    this.applyFilters();
  }

  /**
   *  Funcion para aplicar los filtros a la lista de notificaciones, se filtran las notificaciones según el filtro general y se actualiza la paginación
   * @returns 
   */
  refrescarNoNotificados(): void {
    if (!this.esEstatusNoNotificados()) {
      return;
    }
    this.aplicarFechasPorEstatus();
    this.actualizarTotalesSidebar();
    this.buscar();
  }

  /**
   * Funcion para rastrear notificaciones por su ID
   * @param _: number
   * @param notificacion: Notificacion
   * @returns number
   */

  trackByNotificacion(_: number, notificacion: Notificacion): number {
    return notificacion.idNotificacionICOIJ;
  }

  /**
   * Funcion para obtener el título de la bandeja según el estatus seleccionado
   * @returns string
   */
  get tituloBandeja(): string {
    if (this.iEstatus !== null && Number(this.iEstatus) === 1) {
      return 'Bandeja de Notificaciones / Notificados';
    }

    if (this.iEstatus !== null && Number(this.iEstatus) === 4 && !this.bOrganoSupervisado) {
      return 'Bandeja de Notificaciones / No Notificados';
    }

    if(this.bOrganoSupervisado &&this.iEstatus !== null && Number(this.iEstatus) === 4) {
      return 'Supervisor / Notificaciones pendientes';
    }
  

    return 'Bandeja de Notificaciones / General';
  }

  /**
   * Funcion para obtener si se muestra la opción de selección
   * @returns boolean
   */
  get mostrarSeleccion(): boolean {
    return this.esEstatusNoNotificados();
  }

  /**
   * Funcion para obtener si se ha seleccionado todas las notificaciones
   * @returns boolean
   */
  get estaSeleccionadoTodo(): boolean {
    return this.selectAll;
  }

  /**
   * Funcion para obtener el número total de elementos
   * @returns number
   */
  get totalItems(): number {
    return this.filteredNotificaciones.length;
  }

  /**
   * Funcion para obtener el número total de páginas
   * @returns number
   */
  get totalPages(): number {
    return this.totalItems ? Math.ceil(this.totalItems / this.pageSize) : 1;
  }

  /**
   * Funcion para obtener el índice del primer elemento de la página actual
   * @returns number
   */
  get startItemIndex(): number {
    if (!this.totalItems) {
      return 0;
    }
    return (this.currentPage - 1) * this.pageSize + 1;
  }

  /**
   * Funcion para obtener el índice del último elemento de la página actual
   * @returns number
   */
  get endItemIndex(): number {
    if (!this.totalItems) {
      return 0;
    }
    return Math.min(this.startItemIndex + this.pageSize - 1, this.totalItems);
  }

  /**
   * Funcion para verificar si una notificacion está seleccionada, se verifica si la notificación existe en la lista de notificaciones seleccionadas para notificar
   * @param notificacion 
   * @returns 
   */
  isSeleccionada(notificacion: Notificacion): boolean {
    return this.listaNotificacionesParaNotificar.some(
      (n) => n.idNotificacionICOIJ === notificacion.idNotificacionICOIJ
    );
  }

  /**
   * Funcion para manejar el evento de cambio en la casilla de selección de todas las notificaciones
   * @param event 
   * @returns 
   */
  onToggleSelectAll(event: Event): void {
    if (!this.mostrarSeleccion) {
      return;
    }

    const checked = (event.target as HTMLInputElement).checked;
    this.selectAll = checked;

    if (checked) {
      this.pagedNotificaciones.forEach((notificacion) =>
        this.addNotificacionSeleccionada(notificacion)
      );
    } else {
      this.pagedNotificaciones.forEach((notificacion) =>
        this.removeNotificacionSeleccionada(notificacion)
      );
    }
  }

  /**
   * Funcion para manejar el evento de cambio en la casilla de selección de una notificacion
   * @param notificacion 
   * @param event 
   * @returns 
   */
  onToggleNotificacion(notificacion: Notificacion, event: Event): void {
    if (!this.mostrarSeleccion) {
      return;
    }

    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
      this.addNotificacionSeleccionada(notificacion);
    } else {
      this.removeNotificacionSeleccionada(notificacion);
    }

    this.refreshSelectAllState();
  }

  /**
   * Funcion para manejar el evento de cambio en el tamaño de página
   * @param event 
   */
  onPageSizeChange(event: Event): void {
    const value = Number((event.target as HTMLSelectElement).value);
    if (!Number.isNaN(value) && value > 0) {
      this.pageSize = value;
      this.currentPage = 1;
      this.updatePagination();
      this.refreshSelectAllState();
    }
  }

  /**
   * Funcion para manejar el evento de cambio en la página actual
   */
  goToPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagination();
      this.refreshSelectAllState();
    }
  }

  /**
   * Funcion para manejar el evento de cambio en la página actual
   */
  goToNextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagination();
      this.refreshSelectAllState();
    }
  }

  /**
   * 
   * @param tipo 
   * @param notificacion 
   * @returns 
   */
  abrirModal(tipo: 'archivos' | 'constancia', notificacion: Notificacion): void {
    if (tipo !== 'archivos' || !this.modalArchivosTpl) {
      if (tipo === 'constancia' && this.modalConstanciaTpl) {
        this.abrirModalConstancia(notificacion);
      }
      return;
    }

    this.archivosModal = [];
    this.archivosModalError = '';
    this.archivosModalLoading = true;

    this.modalService.open(this.modalArchivosTpl, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false,
    });


    if (notificacion.iTipoNotificacion == 2 && notificacion.folioEnvio == 0) {
      if (!notificacion.esLaboral) { //SOLO SISE
        this.notificacionesService
          .obtenerDocumentoAcuerdo(notificacion.neun, notificacion.notElecId ?? 0)
          .subscribe({
            next: (archivos) => {
              this.archivosModal = archivos ?? [];
              this.archivosModalLoading = false;
            },
            error: () => {
              this.archivosModalError =
                'Ocurrio un error al cargar los archivos de la notificacion.';
              this.archivosModalLoading = false;
            },
          });
      }
      else { //SOLO SIGE
        this.notificacionesService
          .obtenerDocumentoAcuerdoLab(notificacion.neun, notificacion.notElecId ?? 0)
          .subscribe({
            next: (archivos) => {
              this.archivosModal = archivos ?? [];
              this.archivosModalLoading = false;
            },
            error: () => {
              this.archivosModalError =
                'Ocurrio un error al cargar los archivos de la notificacion.';
              this.archivosModalLoading = false;
            },
          });
      }
    }
    else {
      this.notificacionesService
        .obtenerDocumentosPorNotificacion(notificacion.idNotificacionICOIJ)
        .subscribe({
          next: (archivos) => {
            this.archivosModal = archivos ?? [];
            this.archivosModalLoading = false;
          },
          error: () => {
            this.archivosModalError =
              'Ocurrio un error al cargar los archivos de la notificacion.';
            this.archivosModalLoading = false;
          },
        });
    }



  }
  /**
   * Funcion para abrir el modal de constancia, se asigna la notificación seleccionada a la propiedad notificacionConstancia, se inicializan las propiedades relacionadas con la constancia, se determina la leyenda a mostrar en la constancia dependiendo del tipo de notificación y si contempla ley de amparo, se abre el modal de constancia utilizando el servicio de modal, al cerrar el modal se obtiene la lista de documentos relacionados a la pantalla de términos y condiciones utilizando el uuid de la notificación, si se obtienen documentos se asignan a la propiedad lstDocumentos y se navega a la pantalla de cambio de contraseña inicial
   * @param notificacion 
   */
  private abrirModalConstancia(notificacion: Notificacion): void {
    this.notificacionConstancia = notificacion;
    this.constanciaArchivos = [];
    this.constanciaError = '';
    this.constanciaLoading = true;

    //ART 060426 Validar tipo Laboral para mostrar leyenda en constancia
    if (!notificacion.esLaboral) { //SOLO SISE
      if (notificacion.contemplaLeyAmparo) {
        this.leyenda = 'la fracción II del artículo 30 de la Ley de Amparo';
      }
      else {
        this.leyenda = 'el Acuerdo General 12/2020, del Pleno del Órgano de Administración Judicial  que regula la integración y trámite de expediente electrónico y el uso de videoconferencias en todos los asuntos competencia de los órganos';
      }
    }
    else { //SOLO SIGE
      this.leyenda = 'la fracción I del artículo 745 Ter de la Ley Federal del Trabajo';
    }



    this.modalService.open(this.modalConstanciaTpl!, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false,
    });

    //ART 060426 Se comenta esta sección porque se decidió no mostrar los archivos recibidos en la constancia, pero se deja el código por si en el 
    // futuro se quiere volver a habilitar esta funcionalidad.
    /*  if (notificacion.iTipoNotificacion == 2 && notificacion.folioEnvio == 0) {
        this.notificacionesService.obtenerDocumentoAcuerdo(notificacion.neun, notificacion.notElecId ?? 0).subscribe({
          next: (archivos) => {
            this.constanciaArchivos = archivos ?? [];
            this.constanciaLoading = false;
          },
          error: () => {
            this.constanciaError = 'Ocurrio un error al cargar la constancia.';
            this.constanciaLoading = false;
          },
        });
      }
      else {
        this.notificacionesService.obtenerDocumentosPorNotificacion(notificacion.idNotificacionICOIJ).subscribe({
          next: (archivos) => {
            this.constanciaArchivos = archivos ?? [];
            this.constanciaLoading = false;
          },
          error: () => {
            this.constanciaError = 'Ocurrio un error al cargar la constancia.';
            this.constanciaLoading = false;
          },
        });
      }*/
  }

  /**
   * Funcion para obtener la descripcion de la clasificacion segun su id, se verifica si el id es nulo o indefinido, en ese caso se devuelve la descripción de "Sin Clasificación", de lo contrario se busca la descripción correspondiente al id en el objeto CLASIFICACIONES, si no se encuentra se devuelve "Sin Clasificación"
   * @param id 
   * @returns 
   */
  getClasificacionDescripcion(id?: number): string {
    if (id === null || id === undefined) {
      return CLASIFICACIONES[0];
    }
    return CLASIFICACIONES[id] ?? CLASIFICACIONES[0];
  }

  /**
   * Funcion para obtener el tipo de constancia según el tipo de notificación, se verifica el valor de iTipoNotificacion en la notificación, si es igual a 1 se devuelve "Normal", si es igual a 2 se devuelve "Automática", en cualquier otro caso se devuelve "Sin valor"
   * @param notificacion 
   * @returns 
   */
  getTipoConstancia(notificacion: Notificacion): string {
    const tipo = notificacion?.iTipoNotificacion;
    if (tipo === 1) {
      return 'Normal';
    }
    if (tipo === 2) {
      return 'Automática';
    }
    return 'Sin valor';
  }

  /**
   * Funcion para imprimir la constancia, se obtiene el contenido de la constancia, se crea una nueva ventana para la impresión, se agregan los estilos necesarios y se imprime el contenido
   * @returns 
   */
  imprimirConstancia(): void {
    const content = document.getElementById('constancia-content');
    if (!content) {
      return;
    }

    const ventana = window.open('', '_blank', 'width=900,height=800');
    if (!ventana) {
      return;
    }

    // Clonar el contenido para no afectar el DOM original
    const clonedContent = content.cloneNode(true) as HTMLElement;

    // Convertir rutas relativas de imágenes a absolutas en el clon
    const images = clonedContent.querySelectorAll('img');
    images.forEach(img => {
      if (img.src) {
        // Obtener la URL absoluta y actualizar el atributo src en el HTML
        const absoluteUrl = new URL(img.src, window.location.href).href;
        img.setAttribute('src', absoluteUrl);
      }
    });

    const estilos = `
      <style>
        * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        body { font-family: Arial, sans-serif; margin: 20px; }
        .constancia-titulo { text-align: center; font-weight: 700; font-size: 18px; margin-bottom: 10px; }
        .constancia-subtitulo { text-align: center; font-size: 14px; margin-bottom: 8px; }
        .constancia-logo { display: flex; justify-content: center; align-items: center; }
        .constancia-logo img { width: 143px; height: 137px; margin-bottom: 14px; }
        .constancia-table { width: 100%; border-collapse: collapse; margin-top: 10px; }
        .constancia-table th { background: #EFE6E0; color: #2d2f39; padding: 8px; text-align: left; }
        .constancia-table td { padding: 8px; border: 1px solid #e5e5e5; }
        .constancia-section { margin-top: 12px; }
        .text-muted { color: #6c757d; }
        .me-auto { margin-right: auto; }
      </style>
    `;

    // Configurar DOMPurify para permitir imágenes y sus atributos
    const sanitizedContent = DOMPurify.sanitize(clonedContent.innerHTML, {
      ALLOWED_TAGS: ['div', 'img', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'span', 'p', 'br'],
      ALLOWED_ATTR: ['src', 'alt', 'class', 'style', 'width', 'height', 'colspan', 'rowspan'],
      KEEP_CONTENT: true
    });

    ventana.document.open();
    ventana.document.write(`<html><head><title>Constancia</title>${estilos}</head><body>${sanitizedContent}</body></html>`);
    ventana.document.close();

    // Esperar a que todas las imágenes se carguen antes de imprimir
    const img = ventana.document.querySelector('img');
    if (img) {
      let printed = false;

      const doPrint = () => {
        if (!printed) {
          printed = true;
          ventana.focus();
          ventana.print();
          ventana.close();
        }
      };

      // Si la imagen ya está cargada (desde caché)
      if (img.complete) {
        doPrint();
      } else {
        // Esperar a que la imagen se cargue
        img.onload = doPrint;
        img.onerror = () => {
          console.error('Error al cargar la imagen para impresión');
          doPrint();
        };

        // Timeout de seguridad por si la imagen nunca carga (5 segundos)
        setTimeout(doPrint, 5000);
      }
    } else {
      // Si no hay imagen, imprimir directamente
      ventana.focus();
      ventana.print();
      ventana.close();
    }
  }

  /**
   * Funcion para aplicar los filtros a la lista de notificaciones, se obtiene el valor del filtro general, número de expediente y órgano, se filtran las notificaciones según los valores de los filtros, se actualiza la paginación y se refresca el estado de selección
    * @returns
   */
  private applyFilters(): void {
    const general = this.normalizeFilterValue('filtroGeneral');
    const expediente = this.normalizeFilterValue('numExpediente');
    const organo = this.normalizeFilterValue('organo');

    this.filteredNotificaciones = this.notificaciones.filter((item) => {
      const NotFil = structuredClone(item);
      NotFil.sintesis = '';
      const texto = JSON.stringify(NotFil).toLowerCase();
      const coincideGeneral = general ? this.quitarAcentos(texto).includes(general) : true;
      const coincideExpediente = expediente
        ? (item.expediente ?? '').toLowerCase().includes(expediente)
        : true;
      const coincideOrgano = organo
        ? item.idOrgano.toString().includes(organo)
        : true;

      return coincideGeneral && coincideExpediente && coincideOrgano;
    });

    this.currentPage = 1;
    this.updatePagination();
    this.refreshSelectAllState();
  }

  /** 
   * Función para normalizar el valor de un filtro, se obtiene el valor del control del formulario, se convierte a cadena, se eliminan los espacios en blanco al inicio y al final, se convierte a minúsculas y se eliminan los acentos 
   * */
  private normalizeFilterValue(controlName: string): string {
    return this.quitarAcentos(
      this.filtrosForm.get(controlName)?.value?.toString().trim().toLowerCase() ||
      ''
    );
  }

  /**
   * Función para quitar los acentos de una cadena de texto, se utiliza el método normalize para descomponer los caracteres acentuados en sus componentes básicos y luego se utiliza una expresión regular para eliminar los caracteres de acentuación
   * @param str 
   * @returns 
   */
  quitarAcentos(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  /**
   * Función para componer el parámetro de fecha, se recibe una cadena de texto que representa una fecha y se devuelve la misma fecha
   * @param fecha 
   * @returns 
   */
  private composeFechaParametro(fecha: string): string {
    return fecha;
  }

  /**
   * Función para verificar si el estatus es "No Notificados"
   * @returns 
   */
  private esEstatusNoNotificados(): boolean {
    return Number(this.iEstatus) === 4;
  }
  /**
   * Función para verificar si el estatus es "Notificados"
   * @returns 
   */
  public esEstatusNotificados(): boolean {
    return Number(this.iEstatus) === 1;
  }

  /**
   * Función para obtener las fechas por estatus, si el estatus es "Notificados" se establece la fecha de inicio a un día antes de la fecha actual y la fecha de fin a la fecha actual, si el estatus es diferente se establece la fecha de inicio a 30 años antes de la fecha actual y la fecha de fin a la fecha actual
   * @returns 
   */
  private obtenerFechasPorEstatus(): { fechaInicio: string; fechaFin: string } {
    const fechaFinDate = new Date();
    if (this.esEstatusNotificados()) {
      const fechaInicioDate = new Date(fechaFinDate);
      fechaInicioDate.setDate(fechaInicioDate.getDate() - 1);

      return {
        fechaInicio: this.toDateInputValue(fechaInicioDate),
        fechaFin: this.toDateInputValue(fechaFinDate),
      };
    }

    const fechaInicioDate = new Date(fechaFinDate);
    fechaInicioDate.setFullYear(fechaInicioDate.getFullYear() - 30);

    return {
      fechaInicio: this.toDateInputValue(fechaInicioDate),
      fechaFin: this.toDateInputValue(fechaFinDate),
    };
  }

  /** 
   * Función para aplicar las fechas por estatus, se obtienen las fechas por estatus y se actualizan los valores de los controles de fecha en el formulario sin emitir eventos para evitar búsquedas automáticas
   * */
  private aplicarFechasPorEstatus(): void {
    const { fechaInicio, fechaFin } = this.obtenerFechasPorEstatus();
    this.filtrosForm.patchValue({ fechaInicio, fechaFin }, { emitEvent: false });
  }

  /** Función para convertir un valor a número, se verifica si el valor es nulo, indefinido o una cadena vacía, en ese caso se devuelve null, de lo contrario se intenta convertir el valor a número, si la conversión resulta en NaN se devuelve null, de lo contrario se devuelve el número convertido
   * @param valor 
   * @returns 
   */
  private toNumber(valor: number | string | null | undefined): number | null {
    if (valor === null || valor === undefined || valor === '') {
      return null;
    }

    const numero = Number(valor);
    return Number.isNaN(numero) ? null : numero;
  }

  /**
   * Función para convertir una fecha a un formato compatible con el input de tipo date, se obtiene el año, mes y día de la fecha, se formatea el mes y día para que tengan dos dígitos y se devuelve la fecha en formato "YYYY-MM-DD"
   * */
  private toDateInputValue(date: Date): string {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  /**
   * Función para agregar una notificación seleccionada a la lista de notificaciones para notificar, se verifica si la notificación ya existe en la lista de notificaciones para notificar, si no existe se agrega a la lista utilizando el operador de propagación para crear una nueva lista con la notificación agregada
   * @param notificacion 
   */
  private addNotificacionSeleccionada(notificacion: Notificacion): void {
    if (
      !this.listaNotificacionesParaNotificar.some(
        (n) => n.idNotificacionICOIJ === notificacion.idNotificacionICOIJ
      )
    ) {
      this.listaNotificacionesParaNotificar = [
        ...this.listaNotificacionesParaNotificar,
        notificacion,
      ];
    }
  }

  /** 
   * Función para eliminar una notificación seleccionada de la lista de notificaciones para notificar, se filtra la lista de notificaciones para notificar para crear una nueva lista que excluya la notificación a eliminar
   * @param notificacion 
   */
  private removeNotificacionSeleccionada(notificacion: Notificacion): void {
    this.listaNotificacionesParaNotificar = this.listaNotificacionesParaNotificar.filter(
      (n) => n.idNotificacionICOIJ !== notificacion.idNotificacionICOIJ
    );
  }

  /**
   * función para refrescar el estado de selección de todas las notificaciones, se verifica si se muestra la opción de selección, si no se muestra se establece selectAll en false y se retorna, si no hay notificaciones en la página actual se establece selectAll en false y se retorna, de lo contrario se verifica si todas las notificaciones en la página actual están seleccionadas utilizando el método every, si todas están seleccionadas se establece selectAll en true, de lo contrario se establece selectAll en false
   * @returns 
   */
  private refreshSelectAllState(): void {
    if (!this.mostrarSeleccion) {
      this.selectAll = false;
      return;
    }

    if (!this.pagedNotificaciones.length) {
      this.selectAll = false;
      return;
    }

    this.selectAll = this.pagedNotificaciones.every((notificacion) =>
      this.isSeleccionada(notificacion)
    );
  }

  private resetSeleccion(): void {
    this.listaNotificacionesParaNotificar = [];
    this.selectAll = false;
  }

  private handleSelectionState(): void {
    if (!this.mostrarSeleccion) {
      this.resetSeleccion();
    } else {
      this.refreshSelectAllState();
    }
  }

  private updatePagination(): void {
    if (!this.totalItems) {
      this.currentPage = 1;
      this.pagedNotificaciones = [];
      return;
    }

    const pages = this.totalPages;
    if (this.currentPage > pages) {
      this.currentPage = pages;
    }

    const start = (this.currentPage - 1) * this.pageSize;
    this.pagedNotificaciones = this.filteredNotificaciones.slice(
      start,
      start + this.pageSize
    );
  }

  /**
   * Función para establecer un mensaje de éxito, se limpia cualquier mensaje de éxito existente y se establece el nuevo mensaje, se inicia un temporizador para limpiar el mensaje de éxito después de 4 segundos, si ya existe un temporizador se limpia antes de establecer el nuevo mensaje
   * @param message 
   */
  private setSuccessMessage(message: string): void {
    this.clearSuccessMessage();
    this.successMessage = message;
    this.successTimeoutId = window.setTimeout(() => {
      this.successMessage = '';
      this.successTimeoutId = undefined;
    }, 4000);
  }

  /**
   * Función para limpiar el mensaje de éxito, se verifica si existe un temporizador para limpiar el mensaje de éxito, si existe se limpia el temporizador y se establece successTimeoutId en undefined, se establece successMessage en una cadena vacía
   */
  private clearSuccessMessage(): void {
    if (this.successTimeoutId) {
      clearTimeout(this.successTimeoutId);
      this.successTimeoutId = undefined;
    }
    this.successMessage = '';
  }

  /**
   * Función para actualizar los totales de notificaciones en la barra lateral, se llama al método actualizarTotalesUsuario del servicio de notificaciones, si ocurre un error al actualizar los totales se muestra un mensaje de error en la consola
    * @returns
   */
  private actualizarTotalesSidebar(): void {
    this.notificacionesService.actualizarTotalesUsuario().subscribe({
      error: (error) =>
        console.error('No fue posible actualizar los totales de notificaciones.', error),
    });
  }

  /**
   * Función para notificar las notificaciones seleccionadas, se verifica el número de notificaciones seleccionadas, si no hay seleccionadas se retorna, de lo contrario se muestra un mensaje de confirmación y si se confirma se actualiza el estatus de las notificaciones
   * @returns 
   */
  notificarSeleccion(): void {
    const totalSeleccionadas = this.listaNotificacionesParaNotificar.length;
    if (!totalSeleccionadas) {
      return;
    }


    this.modalConfirmacionService.confirm('Confirmación',
      `Se notificar\u00e1n ${totalSeleccionadas} notificaciones. \u00bfDeseas continuar?`,
      'Aceptar',
      'Cancelar',
      'sm').then((confirmed) => {
        if (confirmed) {
          this.clearSuccessMessage();
          // Estatus al que se cambiará , 1= notificada
          const estatusDestino = 1;
          const realizaNot = (this.authService.getIdOrganoAux() === 0) ? this.authService.getIdOrgan() : this.authService.getIdOrganoAux();
          //  console.log('ID OIJ que realiza la notificación:', realizaNot);
          const items: ActualizarEstatusNotificacionesPslCommand[] =
            this.listaNotificacionesParaNotificar.map((n) => ({
              id: n.idNotificacionICOIJ,
              tipoInterconexion: n.tipoInterconexion,
              nombreArchivo: n.nombreArchivo,
              estatus: estatusDestino,
              idOrgano: n.idOrgano,
              idOij: this.authService.getIdOrgan(),
              catTipoOrganismoIdOij: this.authService.getTipoOrganismo(),
              tipoCuaderno: n.sTipoCuaderno,
              expediente: n.expediente,
              neun: n.neun,
              catTipoAsuntoId: n.catTipoAsuntoId,
              idOIJrealizaNot: realizaNot,
              esLaboral: n.esLaboral
            }));

          //   console.log('Items para actualizar estatus:', items);
          this.loading = true;
          this.errorMessage = '';

          this.notificacionesService
            .actualizarEstatusPsl(items)
            .subscribe({
              next: (resp) => {
                //  console.log('Respuesta ActualizarEstatus:', resp);

                const totalNotificadas = resp?.filasAfectadas ?? totalSeleccionadas;
                this.setSuccessMessage(
                  `Las notificaciones seleccionadas se han notificado. Total: ${totalNotificadas}.`
                );
                this.errorMessage = '';

                // Refrescar la bandeja
                this.buscar();

                // Limpiar selección local
                this.resetSeleccion();

                // Actualizar totales en la barra lateral
                this.notificacionesService.actualizarTotalesUsuario().subscribe({
                  error: () =>
                    console.error('No fue posible refrescar los totales de notificaciones.'),
                });

                this.loading = false;
              },
              error: (err) => {
                console.error('Error al actualizar estatus de notificaciones', err);
                this.errorMessage =
                  'Ocurrió un error al notificar las notificaciones seleccionadas, intenta nuevamente.';
                this.clearSuccessMessage();
                this.loading = false;
              },
            });
        }
      }).catch(() => console.error('Ocurrio un error con la modal de confirmación'));


  }
}
